import { TProject } from 'src/types/project'

export const EPermissionSpecialAuthorization = {
  CAN_VIEW_PATIENT_IDENTITIES: 'CAN_VIEW_PATIENT_IDENTITIES',
  CAN_VIEW_SENSITIVE_DATA: 'CAN_VIEW_SENSITIVE_DATA',
} as const

export type EPermissionSpecialAuthorization =
  (typeof EPermissionSpecialAuthorization)[keyof typeof EPermissionSpecialAuthorization]

export const EPermissionGrantActions = {
  GET: 'GET',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  ALL: 'ALL',
} as const

export type EPermissionGrantActions = (typeof EPermissionGrantActions)[keyof typeof EPermissionGrantActions]

export const EPermissionGrantSubjects = {
  PATIENT: 'PATIENT',
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  CONFIGURATION: 'CONFIGURATION',
  BILLING: 'BILLING',
  PATIENT_REVIEWS: 'PATIENT_REVIEWS',
  STATISTICS: 'STATISTICS',
  HR: 'HR',
  ALL: 'ALL',
} as const

export type EPermissionGrantSubjects =
  (typeof EPermissionGrantSubjects)[keyof typeof EPermissionGrantSubjects]

export type TPermission = {
  id: number
  name: string
  ProjectId: number
  specialAuthorizations: Array<EPermissionSpecialAuthorization>
  grants: Array<TPermissionGrant>
  Project?: TProject
  ipAddressWhiteList?: string[]
}
export type TPermissionGrant = {
  subject: EPermissionGrantSubjects
  actions: Array<EPermissionGrantActions>
}
export type TRequiredPermission = {
  subject: EPermissionGrantSubjects
  action: EPermissionGrantActions
}
export type TPermissionFormValues = {
  name: string
  specialAuthorizations: Array<EPermissionSpecialAuthorization>
  grants: {
    subject: EPermissionGrantSubjects
    actions: Array<EPermissionGrantActions>
  }[]
  ipAddressWhiteList?: string[]
}
export const actionToIntlTitle: Record<EPermissionGrantActions, string> = {
  ALL: 'components.permissions.action-all',
  CREATE: 'components.permissions.action-create',
  DELETE: 'components.permissions.action-delete',
  UPDATE: 'components.permissions.action-update',
  GET: 'components.permissions.action-get',
}
export const subjectToIntlTitle: Record<EPermissionGrantSubjects, string> = {
  ALL: 'components.permissions.subjects.all.title',
  PATIENT: 'components.permissions.subjects.patient.title',
  PATIENT_REVIEWS: 'components.permissions.subjects.patient-reviews.title',
  BILLING: 'components.permissions.subjects.billing.title',
  CONFIGURATION: 'components.permissions.subjects.configuration.title',
  STATISTICS: 'components.permissions.subjects.statistics.title',
  HR: 'components.permissions.subjects.hr.title',
  USER_MANAGEMENT: 'components.permissions.subjects.user-management.title',
}

export const subjectToIntelDescription: Record<EPermissionGrantSubjects, string> = {
  ALL: 'components.permissions.subjects.all.description',
  PATIENT: 'components.permissions.subjects.patient.description',
  PATIENT_REVIEWS: 'components.permissions.subjects.patient-reviews.description',
  BILLING: 'components.permissions.subjects.billing.description',
  CONFIGURATION: 'components.permissions.subjects.configuration.description',
  STATISTICS: 'components.permissions.subjects.statistics.description',
  HR: 'components.permissions.subjects.hr.description',
  USER_MANAGEMENT: 'components.permissions.subjects.user-management.description',
}

export const specialAuthorizationToIntlTitle: Record<EPermissionSpecialAuthorization, string> = {
  CAN_VIEW_PATIENT_IDENTITIES: 'components.permissions.special-authorization-can-view-patient-identities',
  CAN_VIEW_SENSITIVE_DATA: 'components.permissions.special-authorization-can-view-sensitive-data',
}

export const SPECIAL_AUTHORIZATIONS = Object.values(EPermissionSpecialAuthorization)
